import { GroupEditionErrors } from "../models";

/**
 * Return true if the given `keyof GroupEditionErrors` is a "hard" error, meaning,
 * users can't skip it to save an edition.
 *
 * @param error keyof GroupEditionErrors
 *
 * @return boolean
 */
const hardErrors: Partial<Record<keyof GroupEditionErrors, true>> = {
  CapacityAugmentedForInactive: true,
  CapacityGTSmallerClassroom: true,
  CapacityLTEnrollments: true,
};

const isHardError = (error: keyof GroupEditionErrors): boolean => error in hardErrors;

export default isHardError;
